import { ADMIN_VERSION } from '@/mocks/admin-version';

export default function AdminPcOnlyScreen() {
  const features = [
    ['ri-layout-grid-line', '대시보드 및 통계'],
    ['ri-mail-line', 'EAP 문의 관리'],
    ['ri-question-answer-line', 'FAQ 편집'],
    ['ri-newspaper-line', '비타레터 발행'],
    ['ri-advertisement-line', '광고 배너 관리'],
  ];
  return (
    <div className="min-h-screen bg-gray-950 flex flex-col font-['Inter','Pretendard_Variable','Pretendard',sans-serif]">
      <div className="px-6 pt-8 text-white text-lg font-extrabold">VITACARE</div>
      <main className="flex-1 flex flex-col items-center justify-center px-6 py-8">
        <div className="w-16 h-16 flex items-center justify-center bg-white/10 border border-white/10 rounded-2xl mb-5">
          <i className="ri-computer-line text-white text-3xl" />
        </div>
        <h1 className="text-white text-xl font-bold text-center mb-2">PC에서 접속해 주세요</h1>
        <p className="text-gray-400 text-sm text-center leading-relaxed mb-6 max-w-[280px]">관리자 대시보드는 데스크톱·노트북 환경에서만 지원합니다.</p>
        <div className="w-full max-w-[300px] bg-white/5 border border-white/10 rounded-xl divide-y divide-white/[0.06]">
          {features.map(([icon, label]) => (
            <div key={label} className="flex items-center gap-2.5 px-3.5 py-2.5">
              <i className={`${icon} text-gray-500 text-sm`} />
              <span className="text-gray-300 text-xs font-medium">{label}</span>
              <i className="ri-lock-line text-gray-600 text-xs ml-auto" />
            </div>
          ))}
        </div>
      </main>
      <div className="px-6 pb-8 text-center text-gray-600 text-xs">{ADMIN_VERSION.version} · PC 전용</div>
    </div>
  );
}
